var dropzone = {
    imagePreview:function(e){
        var ip = $(e).find('.imagePreview');
        var sortable = (typeof $(ip).data('sortable')!=='undefined')?$(ip).data('sortable'):true;
        $.get($(ip).data('url'),function(res){
            if (sortable){
                $(ip).html('<ul class="sortable"></ul>');
            }else{
                $(ip).html('<ul></ul>');
            }
            var handler = sortable?'<a class="handler btn btn-default btn-xs"><i class="fa fa-arrows"></i></a>':'';
            res.cc.forEach(function(e,i){
                $(ip).find('ul').append('<li class="image" data-id="'+e.id+'">'+handler+'<a class="btn btn-xs btn-danger" ><i class="fa fa-times"></i></a><img src="'+e.img_path+'" /></li>')
            });
            sortable_();
        });
    },
    documentPreview:function(e){
        var dp = $(e).find('.documentPreview');
        $.get($(dp).data('url'),function(res){
            $(dp).html('<ul class="sortable"></ul>');
            res.documentos.forEach(function(e,i){
                $(dp).find('.sortable').append('<li class="document" data-id="'+e.id+'"><a class="handler btn btn-default btn-xs"><i class="fa fa-arrows"></i></a><a class="btn btn-xs btn-danger noload" ><i class="fa fa-times"></i></a><img src="/img/document-icon.png" /> <span>'+e.name+'</span></li>')
            });
            sortable_();
        });
    },
    acceptedFiles:{
        image: "image/jpeg,image/png",
        document:'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'},
    initialize_custom:function(){
        var upload_max_filesize = $("#upload_max_filesize").val();
        // $(".dropzone_custom").dropzone({ url: "/file/post" });
        $(".dropzone_custom").each(function (k, e) {
            var options = {}
            options.url = defined($(e).data('url')) ? $(e).data('url') : '';
            options.maxfilesize = defined($(e).data('maxfilesize')) ? $(e).data('maxfilesize') : undefined;
            options.maxthumbnailfilesize = defined($(e).data('maxthumbnailfilesize')) ? $(e).data('maxthumbnailfilesize') : undefined;
            options.dictdefaultmessage = defined($(e).data('dictdefaultmessage')) ? $(e).data('dictdefaultmessage') : Lang.get('msg.FileUploadMensaje1')+upload_max_filesize.replace('M', 'MB');;
            dropzone_($(e), options);
        });
    }
}



function dropzone_ (e,options ){

    var upload_max_filesize = $("#upload_max_filesize").val();
    //Inicialitzem un element per tal de poder penjar imatges
    //  e. //Jquery element
    //  options. //Object amb opcions

    defined(options)?false:options = {};

    var url = defined(options.url)?options.url:false;
    var maxFilesize = defined(options.maxfilesize)?options.maxfilesize:10;
    var maxThumbnailFilesize = defined(options.maxthumbnailfilesize)?options.maxthumbnailfilesize:5;
    var dictDefaultMessage = defined(options.dictdefaultmessage)?options.dictdefaultmessage:Lang.get('msg.FileUploadMensaje1')+upload_max_filesize.replace('M', 'MB');
    var acceptedFiles = false;
    var type = false;
    if ($(e).hasClass('image')){
        acceptedFiles = dropzone.acceptedFiles.image
        type='image';
    }
    if ($(e).hasClass('document')){
        acceptedFiles = dropzone.acceptedFiles.document;
        type='document';
    }

    $(e).find('.dz-message').append('<span>'+dictDefaultMessage+'</span>');
    e.dropzone({
        url: url,
        maxFilesize: maxFilesize,
        paramName: "uploadfile",
        headers: {
            'X-CSRF-Token': $('meta[name=csrf_token]').attr("content")
        },
        acceptedFiles:acceptedFiles,
        maxThumbnailFilesize: maxThumbnailFilesize,
        init: function () {
            this.on('success', function (file, json) {
                $(".dz-preview").remove();
                e.removeClass('dz-started');
                switch (type) {
                    case 'image':
                        dropzone.imagePreview(e);
                        break;
                    case 'document':
                        dropzone.documentPreview(e);
                        break;
                }

            });
            this.on('error', function (file, json) {
                var maxSize = parseInt(upload_max_filesize.replace("M", '000000'));
                if (file.size >= maxSize) {
                    alert(Lang.get('msg.dropzone-warning')+upload_max_filesize.replace('M', 'MB'));
                }
                else {
                    alert('Error');
                }
            });
        }
    });
    if ($(e).find('.imagePreview').length>0){
        dropzone.imagePreview(e);
    }
    if ($(e).find('.documentPreview').length>0){
        dropzone.documentPreview(e);
    }
};




$(function(){
    if ($(".dropzone_custom").length>0) {
        dropzone.initialize_custom();
    }
});
